import { Input as BUInput } from '@mui/base/Input';
import React from 'react';
import { useAdornments, useCustomClassName } from './shared/Input.hooks.js';
import { HTMLInput, HTMLTextArea, Root, } from './shared/Input.styled';
export const TextInput = ({ size, success, startAdornment, endAdornment, className, slotProps, ...restProps }) => {
    const customClassName = useCustomClassName(success, size, className);
    const { wrappedStartAdornment, wrappedEndAdornment } = useAdornments(startAdornment, endAdornment);
    const mergedSlotProps = {
        ...slotProps,
        input: {
            'data-test': `${restProps.type ?? 'text'}-field`,
            ...slotProps?.input,
        },
    };
    return (React.createElement(BUInput, { "data-testid": "clds-text-field", className: customClassName, slots: { root: Root, input: HTMLInput, textarea: HTMLTextArea }, slotProps: mergedSlotProps, startAdornment: wrappedStartAdornment, endAdornment: wrappedEndAdornment, ...restProps }));
};
//# sourceMappingURL=TextInput.js.map